import * as vp from 'vopay';
import { useContext, useEffect, FunctionComponent, useState } from 'react';
import { useParams } from 'react-router-dom';
import useFetchEFTFundTransaction from '../../hooks/useApi/useFetchEFTFundTransaction';
import AccountContext from '../Accounts/AccountContext';
import EftFundingTransactionInfo from './EftFundingTransactionInfo';
import LinkedTransactionInfo from './LinkedTransactionInfo';

type FC = FunctionComponent<vp.TransactionIdAndType>;

const EftFundingTransactionContainer: FC = (props: vp.TransactionIdAndType) => {
  const { accountId } = useParams<{ accountId: string }>();
  const { TransactionID, Type } = props;

  const { details } = useContext(AccountContext);
  let token = '';
  if (details[accountId]) {
    token = details[accountId].token;
  }
  const [isDataFeched, setIsDataFeched] = useState(false);
  const [subTransactions, setSubTransactions] = useState<vp.LinkedTransactionsMap>();
  const [eftFundTransaction, getEftFundTransaction, resetTransactionsId] = useFetchEFTFundTransaction({
    bearer: token,
  });
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<vp.EftFundingTransactionResponse>();

  useEffect(() => {
    if (Type === vp.TransactionType.EFT_FUNDING) {
      getEftFundTransaction(TransactionID);
    }

    setIsDataFeched(true);
  }, [currentTransactionId]);

  useEffect(() => {
    if (isDataFeched && Object.values(eftFundTransaction).length > 0 && eftFundTransaction.SubTransactions) {
      const subTransactionsList: vp.LinkedTransactionsMap = Object.values(eftFundTransaction.SubTransactions);

      setSubTransactions(subTransactionsList);
    }
  }, [eftFundTransaction]);

  useEffect(() => {
    if (eftFundTransaction) {
      setTransaction(eftFundTransaction);
    }
  }, [eftFundTransaction]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
    resetTransactionsId();
  }

  return (
    <div>
      {transaction && <EftFundingTransactionInfo transaction={transaction} />}
      {subTransactions && <LinkedTransactionInfo LinkedTransactions={subTransactions} />}
    </div>
  );
};

export default EftFundingTransactionContainer;
